import { EventEmitter, Input, Output, Directive } from '@angular/core';
import { CourseTemplate } from '@shared/models';

export interface CreateTemplateEvent {
  template: CourseTemplate;
  templateCardComponent: TemplateCardBaseComponent;
}

@Directive()
export class TemplateCardBaseComponent {
  @Input() template: CourseTemplate;
  @Input() inactive: boolean;
  @Output() templateSelected = new EventEmitter<CreateTemplateEvent>();
  
  public isLoading: boolean;
  public hasFailed: boolean;

  selectTemplate(): void {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.templateSelected.emit({template: this.template, templateCardComponent: this});
  }
}
